<template>
  <base-detail :title="'Roti'">
    <ul>
      <li class="menuList" v-for="item in roti" :key="item.item">
        <span>{{ item.item }}</span>
        <span> {{ item.singlePrice || "----" }} </span>
        <span>{{ item.halfPrice || "----" }}</span>
        <span>{{ item.fullPrice }}</span>
      </li>
    </ul>
  </base-detail>
</template>

<script>
import data from "./../../../data.json";
export default {
  computed: {
    roti() {
      const dataList = data.filter(
        (row) => row.type === "roti" && row.mealType === "main_course"
      );
      return dataList;
    },
  },
};
</script>
